import styled, { css } from 'styled-components';
import {
  Box,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  TextField,
  Typography,
  TableCell,
  Link as MuiLink,
  Drawer,
} from '@material-ui/core';
import { isNil, get } from 'lodash';

import Timeframe from 'components/Timeframe';
import ActivityPanel from 'components/ActivityPanel/ActivityPanel';
import ActionsPanel from 'components/ActionsPanel';
import Alert from 'components/mui/Alert';
import Panel from 'components/Panel';
import DataGrid from 'components/mui/DataGrid';
import Link from 'components/Link';
import Button from 'components/mui/Button';
import Doppler from 'components/Doppler';
import BlIcon from 'components/icons/BlIcon';
import Stepper from 'components/mui/Stepper/Stepper';

const FlexBoxExtend = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    ${theme.breakpoints.up('sm')} {
      flex-direction: row;
      align-items: center;
    }
  `}

  ${({ $css }) =>
    css`
      ${$css}
    `}
`;

export default {
  PageWrapper: styled.div``,

  PageWrapperTop: styled(Grid).attrs({
    component: Box,
  })`
    ${({ theme, mb }) =>
      !mb &&
      css`
        margin-bottom: 10px;
        ${theme.breakpoints.up('sm')} {
          margin-bottom: 20px;
        }
      `}
  `,

  PageWrapperTopPart: styled(FlexBoxExtend)``,

  PageWrapperContent: styled(Box)`
    margin-bottom: 40px;

    ${({ theme, $boxShadow }) =>
      $boxShadow &&
      css`
        ${theme.breakpoints.up('sm')} {
          box-shadow: ${theme.shadows[1]};
        }
      `}
    ${({ display }) =>
      !display &&
      css`
        display: flex;
        flex-wrap: wrap;
      `}
  `,

  PageTitle: styled(Typography).attrs({ variant: 'h3' })`
    margin-bottom: 25px;
    font-size: 1.375rem;

    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        margin-bottom: 0;
        padding-right: 12px;
      }
      ${theme.breakpoints.up('md')} {
        font-size: 1.5rem;
      }
    `}

    ${({ $noMarginBottom }) =>
      $noMarginBottom &&
      css`
        margin-bottom: 0;
      `}
  `,

  PageTitleCaption: styled(Typography).attrs({
    variant: 'caption',
    color: 'secondary',
  })`
    ${({ $marginBottom }) => css`
      font-weight: bold;
      display: block;

      ${$marginBottom &&
      css`
        margin-bottom: ${$marginBottom};
      `}
    `}
  `,

  Timeframe: styled(Timeframe)`
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        max-width: 49%;
        //max-width: 260px;
      }
      ${theme.breakpoints.up('md')} {
        max-width: initial;
      }
    `}
  `,

  ActionsPanel: styled(ActionsPanel)`
    & .MuiIconButton-root {
      ${({ $reducePadding, theme }) =>
        $reducePadding &&
        css`
          padding: 8px;
          // ${theme.breakpoints.up('lg')} {
          //  padding: 12px;
          // }
        `}
    }
  `,

  ActivityPanel: styled(ActivityPanel)`
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        height: 100%;
      }
    `}
  `,

  ActivityBottom: styled.div`
    margin-top: 16px;
  `,

  ActivityList: styled(List)`
    display: flex;
    flex-wrap: wrap;

    ${({ $mobileView, theme }) =>
      $mobileView &&
      css`
        background-color: #fff;
        border-radius: 4px;
        padding: 12px;
        margin-top: 10px;
        margin-bottom: 10px;
        box-shadow: ${theme.shadows[1]};
      `}
  `,

  ActivityListItem: styled(ListItem)`
    padding: 4px 0;
    flex: 1 1 50%;
    max-width: 50%;

    &:nth-child(3n) {
      border-right-color: transparent;
    }
    &:nth-child(4),
    &:nth-child(5),
    &:nth-child(6) {
      border-bottom-color: transparent;
    }

    ${({ theme }) => css`
      //text-align: center;
      flex: 1 1 100%;
      //padding-right: 10px;
      max-width: 100%;
      // border-right: 1px solid ${theme.palette.text.hint};
      // border-bottom: 1px solid ${theme.palette.text.hint};

      ${theme.breakpoints.up('sm')} {
        flex: 1 1 50%;
        max-width: 50%;
        padding-right: 16px;
      }
    `}

    & .MuiTypography-body1 {
      font-weight: normal;
      color: currentColor;
      line-height: 1.2;
    }

    & .MuiTypography-body2 {
      font-size: 10px;
    }
  `,

  ActivityListIcon: styled(ListItemIcon)`
    width: 8px;
    height: 8px;
    background-color: #887354;
  `,

  Panel: styled(Panel)`
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        height: 100%;
      }
    `}
  `,

  PanelButton: styled(Button)`
    margin-top: 20px;
    ${({ $maxWidth, theme }) =>
      $maxWidth &&
      css`
        ${theme.breakpoints.up('sm')} {
          max-width: 300px;
          margin: 20px auto 0;
        }
      `}
  `,

  PanelBottom: styled.div`
    border-top: 1px solid #e2e2e2;
  `,

  PanelSection: styled(Box)(
    ({ theme, $divider = true, $border }) => css`
      ${$divider &&
      css`
        &:not(:last-of-type)::after {
          content: '';
          display: block;
          background: #b4b4b4;
          width: 100%;
          height: 0.5px;
          margin: 24px 0;
          ${theme.breakpoints.up('sm')} {
            margin: 24px -40px;
            width: 105%;
          }
          ${theme.breakpoints.up('lg')} {
            margin: 32px -40px;
            width: 104.4%;
          }
        }
      `}
      ${$border &&
      css`
        &:not(:last-of-type) {
          border-bottom: 1px solid #b4b4b4;
        }
      `} //&:not(:last-child) {
      //  border-bottom: 0;
      //}
    `,
  ),

  NumberPanelItems: styled(Grid)`
    height: calc(100% + 12px);
  `,

  AddCampaignButton: styled(Button)`
    ${({ $margin }) => {
      if (!$margin) {
        return css`
          margin-left: 12px;
        `;
      }
      return css`
        margin: ${$margin};
      `;
    }}
  `,
  AddCampaignIconButton: styled(IconButton)`
    position: fixed;
    bottom: 95px;
    right: 18px;
    z-index: 999;
    ${({ $noPadding }) =>
      $noPadding &&
      css`
        padding: 0;
      `}
    ${({ $marginLeft }) =>
      $marginLeft &&
      css`
        margin-left: ${$marginLeft};
      `}
    i {
      font-size: 3.75rem;
      background: #fff;
      border-radius: 100rem;
    }
  `,

  CampaignIconButton: styled(IconButton)`
    padding: 5px;
    i {
      font-size: 1.5rem;
      border-radius: 100rem;
    }

    ${({ $noPadding }) =>
      $noPadding &&
      css`
        padding: 0;
      `}

    ${({ $marginLeft }) =>
      $marginLeft &&
      css`
        margin-left: ${$marginLeft};
      `}

    ${({ $circle, theme }) =>
      $circle &&
      css`
        background: ${theme.palette.background.dark.main};
        &:hover {
          background: ${theme.palette.background.dark.main};
        }

        i {
          font-size: 0.875rem;
          color: #fff;
        }

        &.Mui-disabled {
          background: ${theme.palette.action.disabled};
        }
      `}
  `,

  DataGrid: styled(DataGrid)`
    & .MuiTableContainer-root {
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
      }
    }
    & .MuiDataGrid-main {
      padding-bottom: 20px;
    }
    & .MuiDataGrid-window {
      top: 50px !important;
      &::-webkit-scrollbar:horizontal {
        height: 37px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #4b748d;
        border: 16px solid #fff;
        border-radius: 40px;
      }
      [data-id='null'] .MuiDataGrid-cellCheckbox {
        visibility: hidden;
      }
    }

    ${({ theme, $fontFamily }) =>
      $fontFamily &&
      css`
        & .MuiDataGrid-columnHeaderTitle {
          font-family: ${theme.typography.fontFamily};
        }
      `}
    ${({ $iconBtnPosition }) =>
      $iconBtnPosition &&
      css`
        & .MuiDataGrid-columnHeader {
          position: relative;
          & .MuiIconButton-root {
            position: absolute;
          }
        }
      `}
    & .MuiDataGrid-columnHeader.analytics-column .MuiDataGrid-iconButtonContainer {
      display: none;
    }
    ${({ $noBoxShadow }) =>
      $noBoxShadow &&
      css`
        & .MuiDataGrid-main {
          box-shadow: none;
        }
      `}

    ${({ $noneIconBtn }) =>
      $noneIconBtn &&
      css`
        & .MuiDataGrid-iconButtonContainer {
          display: none;
        }
      `}
    & .MuiCheckbox-colorPrimary.Mui-checked {
      ${({ theme }) => css`
        color: ${theme.palette.background.dark.main};
      `}
    }
  `,

  FilterSelect: styled(Doppler).attrs(({ component, select }) => {
    return {
      component: component || TextField,
      select: isNil(select) ? true : select,
      margin: 'none',
    };
  })`
    width: 100px;

    ${({ theme, $width }) =>
      $width &&
      css`
        width: 100%;
        ${theme.breakpoints.up('sm')} {
          width: ${$width}px;
        }
      `}

    & .MuiInputBase-root {
      margin-top: 10px;
      padding-left: 2px;
      text-transform: uppercase;
      font-size: 0.75rem;
      font-weight: bold;

      ${({ theme }) => css`
        border-radius: ${theme.shape.borderRadius}px;

        ${theme.breakpoints.up('sm')} {
          margin-top: 0;
          border-radius: 0;
        }

        ${theme.breakpoints.up('md')} {
          padding-left: 0;
          text-transform: none;
          font-size: 1rem;
          font-weight: normal;
        }
      `}
    }

    & .MuiInputBase-input {
      padding-top: 10px;
      padding-bottom: 10px;
      height: 42px;
      align-items: center;
      display: flex;
    }

    & .MuiIcon {
      padding: 0;
    }

    & .MuiAutocomplete-inputRoot {
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 16px;
    }
  `,

  PageTitleButton: styled(Button)`
    padding: 7px;
    min-width: auto;
    border-radius: 100rem;
    margin-left: 10px;
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        border-radius: 4px;
        padding: 8px 22px;
      }
    `}
    .MuiButton-iconSizeSmall {
      margin: 0;

      ${({ theme }) => css`
        ${theme.breakpoints.up('sm')} {
          margin-left: -4px;
          margin-right: 5px;
        }
      `}
      .BlIcon-root {
        font-size: 0.675rem;
        ${({ theme }) => css`
          ${theme.breakpoints.up('sm')} {
            font-size: 1.1rem;
          }
        `}
      }
    }
    ${({ $marginRight }) =>
      $marginRight &&
      css`
        margin-right: 24px;
      `}
  `,

  FilterSelectLabel: styled.span`
    text-transform: uppercase;
    margin-right: 10px;
    ${({ theme }) => css`
      font: 700 0.75rem ${theme.typography.fontFamilyAccent};

      ${theme.breakpoints.up('sm')} {
        margin-right: 7px;
      }
    `};
  `,

  Alert: styled(Alert)`
    margin-bottom: 30px;
  `,

  GridWrapper: styled(Grid)`
    max-width: initial;
    flex: 100%;
    ${({ $css }) =>
      css`
        ${$css}
      `}
  `,

  GridItem: styled(Box).attrs({
    component: Grid,
  })``,

  ButtonsGroup: styled(Box)`
    display: flex;
    align-items: center;
  `,

  ButtonsGroupItem: styled(Button)`
    margin-left: 10px;
    min-width: auto;
    ${({ $noMargin }) =>
      $noMargin &&
      css`
        margin: 0;
      `}
  `,

  SettingsButton: styled(IconButton)`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;

    ${({ theme }) => css`
      background-color: ${theme.palette.background.dark.main};

      &:hover {
        background-color: ${theme.palette.background.dark.main};
      }
    `}

    i {
      font-size: 22px;
    }
  `,

  SettingsDrawer: styled(Drawer)`
    & .MuiDrawer-paper {
      padding: 1.25rem 2rem;
    }
    & .MuiButton-root {
      margin: 0.375rem 0;
    }
  `,

  DataGridLabelItem: styled(Doppler)`
    line-height: 1;
    max-width: 100%;
  `,

  DataGridLabelCaption: styled(Typography).attrs({
    variant: 'caption',
    color: 'textPrimary',
  })`
    display: block;
    font-size: 12px;
    line-height: 1.2;
    margin-top: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
  `,

  DataGridLabelTitle: styled(Doppler).attrs(({ component }) => {
    return {
      $isLink: component === Link || component === 'a',
    };
  })`
    font-size: 16px;
    line-height: 1.2;
    word-break: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    padding-bottom: 2px;

    @supports (-webkit-line-clamp: 2) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: initial;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    ${({ theme, $textPrimary, $isLink }) => {
      return css`
        ${$isLink &&
        css`
          color: ${theme.palette.secondary.main};
          transition: 0.3s ease;

          &:hover {
            font-weight: bold;
            color: ${theme.palette.secondary.main};
          }
        `}

        ${$textPrimary &&
        css`
          color: ${theme.palette.text.primary};
        `}
      `;
    }}
  `,

  DataGridLabelTitleInfo: styled(Typography).attrs({
    variant: 'caption',
    color: 'textPrimary',
  })`
    display: block;
    font-size: 11px;
    line-height: 1.2;
  `,

  DataGridTotalSeeAll: styled(MuiLink)`
    ${({ theme, $color, $shade = 'main' }) => css`
      margin-left: 20px;
      color: ${theme.palette[$color][$shade]};

      &:hover {
        color: ${theme.palette[$color][$shade]};
      }
    `}
  `,

  BackLink: styled(Link)`
    font-size: 12px;
    ${({ theme }) => css`
      color: ${theme.palette.background.dark.main};
      font-weight: bold;
    `}
    .MuiIcon-root {
      ${({ theme }) => css`
        color: ${theme.palette.background.dark.light};
        width: 11px;
        font-size: 11px;
        margin-right: 10px;
      `}
    }
  `,

  Typography: styled(Typography)`
    ${({ $marginBottom }) => {
      if (!$marginBottom) return;
      return css`
        margin-bottom: ${$marginBottom};
      `;
    }}
    ${({ $marginTop }) =>
      $marginTop &&
      css`
        margin-top: ${$marginTop};
      `}
    
    ${({ $marginRight }) =>
      $marginRight &&
      css`
        margin-right: ${$marginRight};
      `}
    
    ${({ $marginLeft }) =>
      $marginLeft &&
      css`
        margin-left: ${$marginLeft};
      `}
    ${({ $textAlign }) =>
      $textAlign &&
      css`
        text-align: ${$textAlign};
      `}

    ${({ $pointer }) =>
      $pointer &&
      css`
        cursor: pointer;
      `}

    ${({ $noWrap }) =>
      $noWrap &&
      css`
        white-space: nowrap;
      `}

    ${({ $button, theme }) =>
      $button &&
      css`
        padding: 4px 12px;
        margin: -4px -12px;
        border-radius: 100rem;

        &:hover {
          background-color: ${theme.palette.info.light};
        }
      `}

      ${({ $bold }) =>
      $bold &&
      css`
        font-weight: bold;
      `} 
      
      ${({ theme, $colorPath }) =>
      $colorPath &&
      css`
        color: ${get(theme.palette, $colorPath)};
      `}

        ${({ $css }) =>
      $css &&
      css`
        ${$css}
      `}
    
    ${({ $paused }) =>
      $paused &&
      css`
        font-style: italic;
        &:before {
          content: '*';
        }
      `}
  `,

  TextButton: styled(Button).attrs({ variant: 'text' })`
    ${({ theme }) =>
      css`
        text-align: left;
        margin-left: -5px;
        font-family: ${theme.typography.fontFamily};

        & .BlIcon-root {
          font-size: 12px;
          margin-top: 3px;
          margin-left: -2px;
        }
      `}

    ${({ $css }) =>
      $css &&
      css`
        ${$css}
      `}
  `,

  TableCell: styled(TableCell)(
    ({ theme, $textAlign, $width }) => css`
      font-size: 1rem;
      line-height: 1.5;
      padding: 7px 10px;
      color: ${theme.palette.text.primary};

      ${theme.breakpoints.up('sm')} {
        border-bottom: none;
        padding: 7px 0;
      }
      ${$width &&
      css`
        width: ${$width};
      `}
      ${$textAlign &&
      css`
        text-align: ${$textAlign};
      `}
    `,
  ),
  TableHeader: styled(TableCell)(
    ({ theme, $textAlign }) => css`
      text-transform: uppercase;
      font-weight: bold;
      border-bottom: none;
      padding: 7px 10px;
      color: ${theme.palette.background.dark.main};

      ${theme.breakpoints.up('sm')} {
        padding: 7px 0;
      }

      ${$textAlign &&
      css`
        text-align: ${$textAlign};
      `}
    `,
  ),

  StyledBox: styled(Doppler)`
    ${({ $css }) =>
      css`
        ${$css}
      `}
  `,

  CustomTableHead: styled(Box)(
    ({ theme }) => css`
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 10px 15px;
      background: #f5f8fb;
      border: 0.5px solid #e2e2e2;
      border-bottom: none;
      border-radius: 10px 10px 0 0;
      font-weight: 700;
      color: ${theme.palette.background.dark.main};
      ${theme.breakpoints.up('md')} {
        padding: 10px 20px;
      }
      ${theme.breakpoints.up('lg')} {
        padding: 10px 45px;
      }

      &.Shadowed {
        box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
        position: relative;
        z-index: ${theme.zIndex.appBar - 1};
      }
    `,
  ),

  CustomTableHeadCell: styled(Typography).attrs({
    variant: 'body2',
  })`
    font-weight: 700;
    display: flex;
    align-items: center;

    ${({ $width }) =>
      $width &&
      css`
        width: ${$width};
      `}
    ${({ $justify }) =>
      $justify &&
      css`
        justify-content: ${$justify};
      `}
  `,

  CustomTableBody: styled.div`
    width: 100%;
    border: 0.5px solid #e2e2e2;
    margin-top: -1px;

    ${({ $thSticky }) =>
      $thSticky &&
      css`
        max-height: calc(100vh - 200px);
        overflow: auto;
      `}

    ${({ $noBorder }) =>
      $noBorder &&
      css`
        border: none;
      `}
  `,

  CustomTableRow: styled(Doppler)(
    ({ theme }) => css`
      &.MuiAccordion-root {
        box-shadow: none;

        &::before {
          display: none;
        }

        //&.Mui-expanded {
        //  margin: 0;
        //}

        & .MuiAccordionDetails-root {
          flex-direction: column;
          padding: 0 15px;

          & .CustomTable-rowInner {
            padding-left: 0;
            padding-right: 0;
          }

          ${theme.breakpoints.up('md')} {
            padding: 0 25px;

            & .CustomTable-rowInner {
              padding-left: 20px;
              padding-right: 20px;
            }
          }

          & .CustomTableRow-errorWrapper {
            ${theme.breakpoints.up('md')} {
              margin: 0 -25px;
            }
          }
        }
      }

      &.CustomTableRow-highlighted {
        background-color: ${theme.palette.secondary.light};
      }

      ${({ $border }) =>
        $border &&
        css`
          border-top: 0.5px solid #e2e2e2;
        `}

      ${({ $trShadow }) =>
        $trShadow &&
        css`
          &:hover {
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.15);
            position: relative;
          }
        `}

    ${({ $bgColor }) =>
        $bgColor &&
        css`
          &:nth-child(even) {
            background-color: #f5f8fb;
          }
        `}

    ${({ $hide }) =>
        $hide &&
        css`
          display: none;
        `}


      ${({ $rowGroupError }) =>
        $rowGroupError &&
        css`
          color: ${theme.palette.error.main};
        `}
    `,
  ),

  CustomTableRowInner: styled(Doppler).attrs({
    className: 'CustomTable-rowInner',
  })`
    display: flex;
    padding: 20px 15px;
    justify-content: space-between;
    flex-wrap: wrap;
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        flex-wrap: nowrap;
      }
      ${theme.breakpoints.up('md')} {
        padding: 20px;
      }
      ${theme.breakpoints.up('lg')} {
        padding: 20px 45px;
      }
    `}
    &.MuiAccordionSummary-root {
      min-height: 0;
      width: 100%;
      padding: 15px;

      ${({ $hideExpandIcon }) =>
        $hideExpandIcon &&
        css`
          pointer-events: none;
          & .MuiAccordionSummary-expandIcon {
            display: none;
          }
        `}

      ${({ theme }) => css`
        ${theme.breakpoints.up('md')} {
          padding: 20px 45px;
        }
      `}
      & .MuiAccordionSummary-content {
        margin: 0;
      }

      & .MuiAccordionSummary-expandIcon {
        margin: -12px;
      }
    }
  `,

  CustomTableRowGroup: styled(Box)``,

  CustomTableCell: styled(Box)(
    ({ $css }) =>
      css`
        ${$css}
      `,
  ),

  BlIconInfo: styled(BlIcon)`
    ${({ theme }) => css`
      margin-top: 3px;
      margin-left: 5px;
      font-size: 0.75rem;
      color: ${theme.palette.background.dark.main};
      display: inline-block;
      overflow: visible;
    `}
    ${({ $marginTop }) =>
      $marginTop &&
      css`
        margin-top: 12px;
        margin-left: 0;
      `}
  `,

  CampaignCap: styled.strong`
    font-size: 1.25rem;
    font-weight: bold;

    ${({ theme }) => css`
      color: ${theme.palette.text.primary};

      font-family: ${theme.typography.fontFamilyAccent};
      ${theme.breakpoints.up('sm')} {
        font-size: 1.875rem;
      }
    `}
  `,

  ViewButtonWrapper: styled.div`
    background-color: #fff;
    padding: 8px 24px;
    text-align: right;
    border-top: 1px solid #b4b4b4;
  `,

  ViewButton: styled(Button)`
    padding: 6px 12px;
    &.MuiButton-root.MuiButton-outlined {
      ${({ theme }) => css`
        font-size: 0.75rem;
        font-family: ${theme.typography.fontFamily};
        text-transform: uppercase;
      `}
    }
    ${({ $flex }) =>
      $flex &&
      css`
        display: flex;
      `}
    ${({ $radius }) =>
      $radius &&
      css`
        border-radius: 100px;
      `}

    ${({ $margin }) =>
      $margin &&
      css`
        margin: ${$margin};
      `}
  `,

  // Campaign info
  TagsWrapper: styled(Box)(
    ({ theme }) => css`
      max-width: 90%;
      ${theme.breakpoints.up('md')} {
        padding: 16px 25px;
      }
    `,
  ),

  CampaignInfoList: styled(List)`
    padding: 0;
    margin-left: 30px;
    width: 75%;

    ${({ $splitColumns }) =>
      $splitColumns &&
      css`
        columns: ${$splitColumns};
      `}
    ${({ $marginLeft }) =>
      $marginLeft &&
      css`
        margin-left: ${$marginLeft};
      `}
    ${({ $marginBottom }) =>
      $marginBottom &&
      css`
        margin-bottom: 24px;
      `}
    ${({ $noMargin }) =>
      $noMargin &&
      css`
        margin: 0;
      `}
  `,
  CampaignInfoListItem: styled(ListItem)`
    padding: 5px 0;
    ${({ $capitalize }) =>
      $capitalize &&
      css`
        text-transform: capitalize;
      `}
    ${({ $bold }) =>
      $bold &&
      css`
        font-weight: bold;
      `}
    ${({ $paused }) =>
      $paused &&
      css`
        font-style: italic;
        &:before {
          content: '*';
        }
      `}
  `,
  SearchInput: styled(TextField)`
    width: 100%;
    margin-top: 8px;

    input {
      height: 42px;
      padding-top: 0;
      line-height: 3;
      padding-bottom: 4px;
      box-sizing: border-box;
    }

    & .MuiInputAdornment-positionEnd {
      margin-right: 10px;
      color: ${({ theme }) => theme.palette.background.dark.main};
    }
    ${({ $marginRight }) =>
      $marginRight &&
      css`
        margin-right: ${$marginRight};
      `}

    ${({ theme, $maxWidth }) =>
      $maxWidth &&
      css`
        ${theme.breakpoints.up('sm')} {
          max-width: 175px;
        }
        ${theme.breakpoints.up('lg')} {
          max-width: 210px;
        }
      `}
  `,
  Stepper: styled(Stepper)`
    ${({ theme }) =>
      css`
        .MuiStepConnector-active .MuiStepConnector-line {
          width: 50%;
          position: relative;
          &:after {
            content: '';
            width: 100%;
            position: absolute;
            bottom: 0;
            right: -100%;
            opacity: 0.375;
            border-top-style: solid;
            border-top-width: 0.5rem;
          }
        }
        ${theme.breakpoints.up('md')} {
          &.MuiStepper-root {
            padding: 25px 0;
          }
          & .MuiStep-root {
            display: block;
            background-color: transparent;
            border: none;
            height: auto;
            flex-grow: unset;
            margin: 0;
          }
          & .MuiStepIcon-root {
            font-size: 2.25rem;
          }
          & .MuiStep-horizontal {
            padding: 0;
          }
          & .MuiStepConnector-root {
            display: inline-block;
          }
          & .MuiStepLabel-labelContainer {
            display: none;
          }
          & .MuiStepButton-root {
            padding: 0.5rem 0.9rem;
          }
        }
        ${theme.breakpoints.up('md')} {
          width: 65%;
        }
      `}

    ${({ $maxWidth, theme }) =>
      $maxWidth &&
      css`
        ${theme.breakpoints.up('md')} {
          max-width: ${$maxWidth};
        }
      `}
  `,
  DataGridHeadColumn: styled(TextField)`
    & .MuiInputBase-multiline {
      padding: 0;
    }
    & .MuiInputBase-input {
      font-size: 0.75rem;
      font-weight: bold;
      text-transform: uppercase;
      height: 50px !important;
      ${({ theme }) => css`
        color: ${theme.palette.background.dark.main};
      `}
    }
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }
  `,
};
